
import { Component, Ref, Watch } from 'vue-property-decorator'
import Widget from '@/components/Widget/Widget.vue'
import RemoteEntity from '@/models/RemoteEntity'
import IconAction from '@/components/IconAction/IconAction.vue'
import SearchInput from '@/components/SearchInput/SearchInput.vue'
import DataTable from '@/components/DataTable/index.vue'
import { getModule } from 'vuex-module-decorators'
import SystemtModule from '@/store/SystemModule'
import WebMessage from '@/models/WebMessage'
import ViewModel from '@/models/ViewModel'
import CompanyPicker from '@/components/CompanyPicker/CompanyPicker.vue'
import remote_entity_fields from './remote-entity-fields'
import RemoteDetails from './components/RemoteDetails.vue'

@Component({
  components: {
    Widget,
    IconAction,
    SearchInput,
    DataTable,
    CompanyPicker,
    RemoteDetails,
  },
})
export default class RemoteEntitiesHome extends ViewModel {
  @Ref() readonly dataTable!: HTMLFormElement

  public company: RemoteEntity = new RemoteEntity()

  public query: string[] = ['status:pending']

  public fields: any = []

  public page_size: number = 25

  public sort_by: string = 'updated_at'

  public show_filter_helper: boolean = false

  public sort_desc: boolean = true

  public page: number = 1

  public records: number = 0

  public loading: boolean = false

  public ready: boolean = false

  public clipboard: string = ''

  // dataTable field filters
  public fieldFilters: any = {
    created_at: '',
    updated_at: '',
    type: '',
  }

  public modal: any = {
    delete: false,
  }

  public filter_mode: string = 'exclusive'

  @Watch('filter_mode')
  public onFilterModeChange() {
    this.refresh()
  }

  public query_settings: any = {
    custom_fields: [
      {
        name: 'type:advertiser',
        value: 'type:advertiser',
        description: 'Include only advertisers',
      },
      {
        name: 'status:Pending',
        value: 'status:pending',
      },
      {
        name: 'status:Approved',
        value: 'status:approved',
      },

      //   {
      //     name: 'is:archived',
      //     value: 'is:archived',
      //     description: 'Include only archived entities',
      //   },
      //   {
      //     name: 'is_not:archived',
      //     value: 'is_not:archived',
      //     description: 'Include only active entities',
      //   },
    ],
  }

  public get show_fields() {
    return this.fields.filter((f: any) => f.show)
  }

  public companies(context: any) {
    this.loading = true

    const field_filters = Object.keys(this.fieldFilters)
      .filter((key: string) => this.fieldFilters[key] !== '')
      .map((key: string) => `${key}:${this.fieldFilters[key].toLowerCase()}`)
    this.syncFilters()
    return RemoteEntity.paginate({
      page_size: context.perPage,
      page: context.currentPage,
      order_by: context.sortBy,
      order: context.sortDesc ? 'desc' : 'asc',
      query: [...context.filter, ...field_filters],
      mode: this.filter_mode,
    }).then(result => {
      this.records = result.records
      this.loading = false
      setTimeout(() => {
        let rowIndex = this.dataTable.dataTable.localItems.findIndex(
          (item: any) => item.id === this.$route.query.edit,
        )
        if (rowIndex >= 0) {
          this.dataTable.dataTable.localItems[rowIndex].add_company = true
        }
      }, 800)
      result.data.map((d: RemoteEntity) => {
        d.updateChecksum()
        return d
      })
      return result.data
    })
  }

  public confirmDelete(company: RemoteEntity) {
    this.company = company
    this.modal.delete = true
  }

  public deleteCompany() {
    this.company.delete().then(() => {
      this.dataTable.refresh()
    })
  }

  public createCompany() {
    this.$router.push('/app/company')
  }

  public editCompany(id: string) {
    this.$router.push(`/app/company/${id}`)
  }

  public mounted() {
    if (this.$route.query.edit) {
      this.loading = true
      // remove is:pending
      this.query = this.query.filter((q: string) => !q.includes('status:pending'))
      this.query.push(`id:${this.$route.query.edit}`)
      this.fieldFilters.id = this.$route.query.edit
    } else {
      this.loadFilters()
    }

    this.fields = remote_entity_fields

    // RemoteEntity.cacheUsedCompanies() //uncomment to cache used companies, and not repeat them in other rows
  }

  public checkDetails(item: any) {
    this.$router.push({ name: 'company-details', params: { id: item.id } })
  }

  public syncFilters() {
    const system = getModule(SystemtModule)
    system.updateState({
      name: 'filters',
      type: 'remote-entity',
      data: { query: this.query, fieldFilters: this.fieldFilters, mode: this.filter_mode },
    })
  }

  public loadFilters() {
    const system = getModule(SystemtModule)
    system.getFilter('remote-entity').then((filter: any) => {
      if (filter) {
        this.query = filter.query
        this.fieldFilters = filter.fieldFilters
        this.filter_mode = filter.mode
      }
      this.ready = true
    })
  }

  public clearFilters() {
    const system = getModule(SystemtModule)
    system.updateState({
      name: 'filters',
      type: 'remote-entity',
      data: null,
    })
  }

  // Refresh dataTable
  public refresh() {
    if (this.$route.query.edit) {
      this.query = this.query.filter((q: string) => !q.includes(`id:${this.$route.query.edit}`))
      delete this.fieldFilters.id
      this.$router.replace({ name: 'remote-companies' })
    }
    this.dataTable.refresh()
  }

  // Reset filters
  public resetFilters() {
    this.fieldFilters = {
      created_at: '',
      updated_at: '',
      type: '',
    }
    this.query = []
    this.filter_mode = 'exclusive'
    this.clearFilters()
    this.refresh()
  }

  public copy(val: string) {
    this.clipboard = val
    // @ts-ignore
    this.$refs.clipboard.setAttribute('type', 'text')

    setTimeout(() => {
      // @ts-ignore
      this.$refs.clipboard.select()

      let status = false

      try {
        status = document.execCommand('copy')
      } catch (e) {
        status = false
      }

      // @ts-ignore
      this.$refs.clipboard.setAttribute('type', 'hidden')

      if (status) {
        WebMessage.success('ID was copied to your clipboard!')
      } else {
        WebMessage.error(
          `Ops! We were not able to copy to your clipboard, please copy: ${this.clipboard}`,
        )
      }
    }, 100)
  }

  public hideSelectPicker(row: any) {
    const el: any = this.$refs[`company-ref-wrap-${row.item.id}`]

    if (el) {
      el.classList?.remove('smooth-slide-in-top')
      el.classList?.add('smooth-slide-out-top')
      setTimeout(() => {
        el.classList?.remove('smooth-slide-out-top')

        if (row.item.oldValues && row.item.oldValues.hasOwnProperty('company_id')) {
          row.item.company_id = row.item.oldValues.company_id
        }
        row.item.add_company = false

        if (this.$route.query.edit) {
          this.refresh()
        }
      }, 400)
    }
  }

  public closeOthers(row: RemoteEntity) {
    let items = this.dataTable.dataTable.localItems.filter((item: any) => item.add_company)
    items.forEach((item: any) => {
      if (item.id !== row.id) {
        item.add_company = false
      }
    })
  }

  public confirmSave(item: RemoteEntity) {
    const pass = () => {
      item.approved(() => this.refresh())
    }

    if (!item.is_dirty) {
      item.add_company = false
      return
    }

    WebMessage.confirm(
      'This action will update all related Media plans and Line items. Are you sure that you want to save?',
      item.name,
      {
        okTitle: 'Confirm',
      },
    ).then((value: boolean) => {
      if (value) {
        pass()
      }
    })
  }
}
